import { Button, Flex } from "@chakra-ui/react";
import { useNewOrderStore } from "../../../stores/order.store";
import Tooltip from "../../../components/Tooltip";
import { getIsValidateDisabled } from "./OrdersNewPageBaseLayoutButton.utils";

/**
 * Base layout buttons. Go back and continue.
 */
export const OrdersNewPageBaseLayoutButton = ({
  validateLabel = "Continuer",
  validateTooltip,
  onValidate,
  allowInvalidSubmit = false,
}: {
  validateLabel?: string;
  validateTooltip?: (isValid: boolean) => string | undefined;
  onValidate?: () => void;
  allowInvalidSubmit?: boolean;
}) => {
  const { goPreviousStep, goNextStep, canGoNextStep } = useNewOrderStore();
  const can = canGoNextStep();

  const isValidateDisabled = getIsValidateDisabled(can, allowInvalidSubmit);

  const handleContinue = async () => {
    if (isValidateDisabled) {
      return;
    }

    if (onValidate) {
      return onValidate();
    }

    goNextStep();
  };
  const tooltipContent = validateTooltip ? validateTooltip(can) : undefined;
  return (
    <Flex gap="4">
      <Button variant="outline" w="fit-content" onClick={goPreviousStep}>
        Retour
      </Button>
      {tooltipContent === null || tooltipContent === undefined ? (
        <Button
          w="fit-content"
          bgColor="brand.700"
          color="white"
          isDisabled={isValidateDisabled}
          onClick={handleContinue}
        >
          {validateLabel}
        </Button>
      ) : (
        <Tooltip content={tooltipContent}>
          <Button
            w="fit-content"
            bgColor="brand.700"
            color="white"
            isDisabled={isValidateDisabled}
            onClick={handleContinue}
          >
            {validateLabel}
          </Button>
        </Tooltip>
      )}
    </Flex>
  );
};
